<template>
    <div>
        Chatbot credit is done.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatBotCreditDone",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
